var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIconMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65 4.02A15.772 15.772 0 0116 .166C24.745.167 31.834 7.256 31.834 16a15.77 15.77 0 01-2.866 9.089L23.917 16h4.75A12.666 12.666 0 007.229 6.861L5.65 4.02zm20.7 23.961A15.772 15.772 0 0116 31.834C7.256 31.834.167 24.745.167 16c0-3.382 1.06-6.517 2.866-9.088L8.083 16h-4.75a12.666 12.666 0 0021.439 9.14l1.579 2.841z",
    fill: "#0075FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIconMobile);
export default __webpack_public_path__ + "static/media/refresh-icon-mobile.882dc0b5b6dc3f3ae1b8e33b7f42f949.svg";
export { ForwardRef as ReactComponent };